:host {
  display: flex;
  /** @prop --number-input-border-width: Set the border width of the number input. */
  --number-input-border-width: var(--p-size-static-0125);

  /** @prop --number-input-padding-top: Set the top padding of the number input. */
  --number-input-padding-top: 14px;

  /** @prop --number-input-padding-right: Set the right padding of the number input. */
  --number-input-padding-right: 20px;

  /** @prop --number-input-padding-bottom: Set the bottom padding of the number input. */
  --number-input-padding-bottom: 14px;

  /** @prop --number-input-padding-left: Set the left padding of the number input. */
  --number-input-padding-left: 20px;

  /** @prop --number-input-border-color: Set the border color of the number input. */
  --number-input-border-color: var(---s-color-border-default);

  /** @prop --number-input-border-color-hover: Set the border color of the number input on hover. */
  --number-input-border-color-hover: var(--s-color-outline-default);

  /** @prop --number-input-border-color-focus: Set the border color of the number input when focused. */
  --number-input-border-color-focus: var(--s-color-outline-default);

  /** @prop --number-input-border-color-warning: Set the border color of the number input for warning states. */
  --number-input-border-color-warning: var(--s-color-border-error);

  /** @prop --number-input-border-color-error: Set the border color of the number input for error states. */
  --number-input-border-color-error: var(--s-color-border-error);

  /** @prop --number-input-border-color-readonly: Set the border color of the number input when readonly. */
  --number-input-border-color-readonly: var(--s-color-border-form-disabled);

  /** @prop --number-input-border-color-disabled: Set the border color of the number input when disabled. */
  --number-input-border-color-disabled: var(--s-color-border-form-disabled);

  /** @prop --number-input-max-width: Set the max width of the number input. */
  --number-input-max-width: 328px;

  /** @prop --number-input-width: Set the width of the number input. */
  --number-input-width: 100%;

  max-width: var(--number-input-max-width);
}

.anchor-c-number {
  width: var(--number-input-width);
  &__container {
    display: flex;
    position: relative;
  }
  &__spinner-add {
    right: 0;
  }
  .input {
    --input-border-width: var(--number-input-border-width);

    --input-padding-top: var(--number-input-padding-top);
    --input-padding-right: var(--number-input-padding-right);
    --input-padding-bottom: var(--number-input-padding-bottom);
    --input-padding-left: var(--number-input-padding-left);

    --border-color: var(--number-input-border-color);
    --border-color-hover: var(--number-input-border-color-hover);
    --border-color-focus: var(--number-input-border-color-focus);
    --border-color-warning: var(--number-input-border-color-warning);
    --border-color-error: var(--number-input-border-color-error);
    --border-color-readonly: var(--number-input-border-color-readonly);
    --border-color-disabled: var(--number-input-border-color-disabled);

    width: 100%;
  }
}

[class*='__spinner'] {
  border: none;
  background: none;
  height: 47px;
  bottom: 0;
  position: absolute;
}
